import React from 'react';
import styles from './index.module.css';

import MainImg from '../../assests/people.webp';
import { useNavigate } from 'react-router-dom';

import { AiOutlineArrowDown } from 'react-icons/ai';

const LandingPage = () => {
	const navigate = useNavigate();
	return (
		<div className={styles.container}>
			<div className={styles.main}>
				<div className={styles.top}>
					<h2>Welcome to Ovet</h2>
					<h3>Bring power to the people * </h3>

					<h2> * Actually</h2>

					<button
						className={styles.dashboardBtn + ' ' + styles.btn}
						onClick={() => {
							navigate('/dashboard');
						}}
					>
						Let's hear you
					</button>

					<button className={styles.moreBtn + ' ' + styles.btn}>
						{' '}
						<a href="#more">
							Hear us out <AiOutlineArrowDown />
						</a>
					</button>
				</div>
				<div className={styles.illustration}>
					<img src={MainImg} alt="" />
				</div>
			</div>

			<p className={styles.desc}>
				We believe that power should belong in hands of the people.
			</p>

			<ul className={styles.why} id="more">
				<h2>Why Ovet ?</h2>
				<li>
					Don't trust anyone? No Worries, you don't need to.
					Blockchain solves this problem for us.
				</li>
			</ul>
		</div>
	);
};

export default LandingPage;
